export default "__VITE_ASSET__BfTDonqU__"